import { AxiosResponse } from 'axios';
import { api } from '../providers/base-api';

export type GenerateUnifiedReceiptParams = {
  dailyWorks: {
    dateBegin: string;
    dateEnd: string;
    users: number[];
  };
  transports: {
    items: {
      user: { id: number };
      rechargeValue: string;
      days: string[];
    }[];
  };
};

export async function generateUnifiedReceiptRequest(
  data: GenerateUnifiedReceiptParams,
): Promise<AxiosResponse<Blob>> {
  const response = await api.post<Blob>('/unified-receipts/generate', data, {
    responseType: 'blob',
  });

  return response;
}

export type UserReceiptValueType =
  | 'daily-work'
  | 'saturday-daily-work'
  | 'sunday-daily-work'
  | 'aditionar-hour'
  | 'daily-adjustment'
  | 'aditional-nocturne';

export type UserReceiptParams = {
  totalPrice: string;
  values: {
    type: UserReceiptValueType;
    price: string;
    amount?: string;
    date?: string;
    dayOfWeek?: number;
  }[];
  totalExtraHours?: string;
  username: string;
  dates: string[];
};

export type TransportReceiptValueType = 'transport' | 'transport-discount';

export type TransportReceiptParams = {
  totalPrice: string;
  username: string;
  values: {
    type: TransportReceiptValueType;
    price: string;
    date?: string;
  }[];
  dates: string[];
  isTotalPriceNegative?: boolean;
};

export type PreviewUnifiedReceiptResponse = {
  dailyParams: UserReceiptParams[];
  transportParams: TransportReceiptParams[];
};

export async function previewUnifiedReceiptRequest(
  data: GenerateUnifiedReceiptParams,
): Promise<AxiosResponse<PreviewUnifiedReceiptResponse>> {
  const response = await api.post<PreviewUnifiedReceiptResponse>(
    '/unified-receipts/preview',
    data,
  );
  return response;
}
